import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { convertFromQueryToNewUiFormat, QueryFormatFilter } from '@hotjar/global-filters';
import {
  RECORDING_INDEX_STORAGE_KEY,
  SEARCH_CONTEXT_STORAGE_KEY,
} from '../../../store/player/slices/recordingsListSlice/constants';
import { getRecordingPath } from '../../../utils/getRecordingPath';

import type { Recording as PlaybackRecording } from '@hotjar/webapp/features/Playbacks/types';
import type { Recording } from '@hotjar/webapp/domains/recordings/types';

export const onRecordingsClick = (
  recording: Recording,
  recordings: Recording[],
  filters: QueryFormatFilter,
  sortBy: string,
  recordingsRequestTimeRange: number[],
) => {
  LocalStorage.set(SEARCH_CONTEXT_STORAGE_KEY, {
    sortBy,
    recordingsRequestTimeRange,
    jsonFilters: filters,
  });
  LocalStorage.set(
    RECORDING_INDEX_STORAGE_KEY,
    recordings.findIndex((r) => r.id === recording.id),
  );

  // Similarly, store the filters used in the current search.
  // This will allow us to "jump start" recordings to the first action which matches the filters.
  const readableFilters = convertFromQueryToNewUiFormat(filters);
  LocalStorage.set('recordingFiltersUiFormat', readableFilters);

  window.open(
    getRecordingPath(recording as unknown as PlaybackRecording, 'recordings-overview'),
    '_blank',
  );
};
